import React, { Component } from 'react';

import classes from './ButtonIconConfirm.css';
import Confirm from './Confirm/Confirm';
import Aux from '../../../hoc/Auxiliary/Auxiliary';

class ButtonIconConfirm extends Component {

  state = {
    showConfirm: false
  }

  render() {
    return (
      <Aux>
      <Confirm
        clicked={this.props.clicked}
        show={this.state.showConfirm}
        confirmText={this.props.confirmText}
        closeCard={() => this.setState({ showConfirm: false })} />
      <button
        className={[classes.Button, this.props.btnClass, classes[this.props.btnType], this.props.small ? classes.Small : null].join(' ')}
        style={this.props.style}
        onClick={() => this.setState({ showConfirm: true })}>
        <img
          className={this.props.iconClass}
          src={this.props.iconSource}
          alt={this.props.iconAlt} />

        <p className={classes.ButtonText}>{this.props.children}</p>
      </button>
      </Aux>
    );
  }
};

export default ButtonIconConfirm;



// WEBPACK FOOTER //
// ./src/components/UI/ButtonIconConfirm/ButtonIconConfirm.js